import api from './api';

export const submitContact = async (data) => {
    try {
        const response = await api.post('/api/contact', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};



